import React, { useContext, useEffect } from "react";
import Button from "Components/button/Button";
import { AuthContext } from "@/App";
import { t } from "i18next";
import { Icon, emailDeliveryAccessRequest } from "Icons/index.js";
import { useHistory } from "react-router-dom";

const AccessRequest = () => {
  const { getLoggedUser } = useContext(AuthContext);
  const history = useHistory();
  const user = getLoggedUser();
  const onWaitlist = user?.delivery_waitlist && !user.delivery_waitlist_accepted_on;

  useEffect(() => {
    if (user.delivery_waitlist_accepted_on) {
      history.replace("/delivery");
    }
    //eslint-disable-next-line
  }, []);

  const isPaidUser = user.plan === "paid";

  return (
    <div className="contentWrapper">
      <div className="items-center screenContainer">
        <div className="mt-4 w-full max-w-[--form-page-width]">
          <div className="sectionTitle">{t("delivery.accessRequest.step1.title")}</div>
          <div
            className="sectionDesc"
            dangerouslySetInnerHTML={{ __html: t("delivery.accessRequest.step1.desc") }}
          ></div>
          <div className="section"></div>

          <div className="flex justify-center mt-8">
            <Button onClick={() => history.push("/orders")}>button.buyMailboxes</Button>
          </div>
        </div>

        <div className="formSection">
          <Icon svg={emailDeliveryAccessRequest} width={320} />
        </div>
      </div>
    </div>
  );
};

export default AccessRequest;
